import React, { useState } from 'react';
import { Plus } from 'lucide-react';

const StepContact = ({ formData, onChange }) => {
  const [showSecondPhone, setShowSecondPhone] = useState(false);

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-orpi-secondary">
        Comment peut-on vous contacter ?
      </h2>

      <p className="text-gray-600 mb-8">
        Indiquez ici vos coordonnées afin de pouvoir recevoir les documents et informations liés à votre demande.
      </p>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Adresse e-mail
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={onChange}
            className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
            placeholder="exemple@exemple.com"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1 text-orpi-secondary">
            Numéro de mobile
          </label>
          <input
            type="tel"
            name="telephoneContact"
            value={formData.telephoneContact}
            onChange={onChange}
            className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
            placeholder="06 00 00 00 00"
            required
          />
        </div>

        {showSecondPhone && (
          <div>
            <label className="block text-sm font-medium mb-1 text-orpi-secondary">
              Autre numéro de téléphone
            </label>
            <input
              type="tel"
              name="telephoneSecondaire"
              value={formData.telephoneSecondaire || ''}
              onChange={onChange}
              className="w-full p-3 border rounded-lg focus:border-orpi-primary focus:ring-orpi-primary"
              placeholder="01 00 00 00 00"
            />
          </div>
        )}

        {!showSecondPhone && (
          <button
            type="button"
            onClick={() => setShowSecondPhone(true)}
            className="flex items-center text-orpi-primary hover:text-orpi-dark"
          >
            <Plus className="w-4 h-4 mr-2" />
            Ajouter un autre numéro
          </button>
        )}
      </div>
    </div>
  );
};

export default StepContact;